import * as yup from 'yup';

export const landingContactSchema = yup.object({
  firstName: yup.string().trim().required('First name is required').max(100),
  lastName: yup.string().trim().required('Last name is required').max(100),
  email: yup
    .string()
    .trim()
    .required('Email is required')
    .email('Enter a valid email address')
    .max(254),
  shelterName: yup
    .string()
    .trim()
    .required('Shelter name is required')
    .max(200),
  annualIntake: yup
    .string()
    .trim()
    .required('Select your annual animal intake'),
  shelterSystem: yup
    .string()
    .trim()
    .required('Select your current shelter system'),
  message: yup.string().trim().max(2000).optional(),
  /** Honeypot — must stay empty; not shown to users. */
  botField: yup.string().max(0, 'Invalid submission'),
});

export type LandingContactFormValues = yup.InferType<typeof landingContactSchema>;

export const landingContactInitialValues: LandingContactFormValues = {
  firstName: '',
  lastName: '',
  email: '',
  shelterName: '',
  annualIntake: '',
  shelterSystem: '',
  message: '',
  botField: '',
};
